/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useNavigate } from 'react-router-dom';


const Footer = () => {
    const navigate = useNavigate();

    const goToDoc = () => {
        window.open('https://docs.tinyblock.io')
    }

    const goToKit = () => {
        window.open('https://drive.google.com/drive/folders/1DATfqAoOjYAnE5EXlebs2pDx54si5kKC')
    }
    const goToX = () => {
        window.open('https://x.com/TinyBlock_io')
    }
    const goToApplyIDO = () => {
        window.open('https://forms.gle/rdL9JAQmq5EoV1AY9')
    }
    const goToApplyAirdrop = () => {
        window.open('https://forms.gle/ePpeVJPqkedQC5Fv9')
    }
    const goToApplyGame = () => {
        window.open('https://forms.gle/W64kDFEjgNifFQq56')
    }
    const goToDiscord = () => {
        window.open('https://discord.gg/M2TaS3ZQhY')
    }
    const goToTele = () => {
        window.open('http://t.me/tinyblock_io')
    }
    const goToYou = () => {
        window.open('https://www.youtube.com/@TinyBlock_io')
    }
    const goToSub = () => {
        window.open('https://substack.com/@tinyblock')
    }

    const goToStaking = (event: any) => {
        event.preventDefault();
        // navigate('/staking');
    }
    const goToIDO = () => {
        navigate('/launchpads');
    }
    const goToAir = (event: any) => {
        event.preventDefault();
        // navigate('/airdrop');
    }
    const goToGame = (event: any) => {
        event.preventDefault();
        // navigate('/gamehub');
    }
    const goToNFT = (event: any) => {
        event.preventDefault();
        navigate('nft');
    }
    const goToPrivacy = () => {
        navigate('/privacy');
    }
    const goToTerms = () => {
        navigate('/terms');
    }
    const goToHome = () => {
        navigate('/');
    }

    return (
        <>
            <footer className="footer">
                <div className="container">
                    <div className="wrap-footer">
                        <div className="left">
                            <div className="logo" onClick={goToHome}>
                                <img src="/images/logo.png" alt="" />
                            </div>
                            <div className="desc">
                                TinyBlock - <span>Fuel your Launch. Fund your Future</span>
                            </div>
                            <div className="community">
                                {/* <div className="txt">
                                    Community
                                </div> */}
                                <div className="social">
                                    <img onClick={goToX} src="/images/s-x.png" alt="" />
                                    <img onClick={goToTele} src="/images/s-t.png" alt="" />
                                    <img onClick={goToDiscord} src="/images/s-d.png" alt="" />
                                    <img onClick={goToYou} src="/images/icon-social-y.png" alt="" />
                                    <img onClick={goToSub} src="/images/icon-social-sub.png" alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="right">
                            <div className="list-menu">
                                <div className="item-menu">
                                    <div className="txt">
                                        Features
                                    </div>
                                    <a onClick={goToIDO} href="">Launchpad</a>
                                    <a
                                        onClick={goToStaking}
                                    // href="#"
                                    >Staking</a>
                                    <a
                                        onClick={goToNFT}
                                    >NFT</a>
                                    <a
                                        onClick={goToAir}
                                        href="#">Airdrop</a>
                                    <a
                                        onClick={goToGame}
                                    //href="#"
                                    >Gamehub</a>
                                </div>
                                <div className="item-menu">
                                    <div className="txt">
                                        Resources
                                    </div>
                                    <a onClick={goToDoc} href="" target='_blank'>Docs</a>
                                    <a onClick={goToKit} href="" target='_blank'>Media Kit</a>
                                </div>
                                <div className="item-menu">
                                    <div className="txt">
                                        Services
                                    </div>
                                    <a onClick={goToApplyIDO} href="" target='_blank'>Apply for IDO</a>
                                    <a onClick={goToApplyAirdrop} href="" target='_blank'>Apply for Airdrop</a>
                                    <a onClick={goToApplyGame} href="" target='_blank'>Apply for Gamehub</a>
                                </div>
                                <div className="item-menu">
                                    <div className="txt">
                                        Legal
                                    </div>
                                    <a onClick={goToPrivacy} href="">Privacy Policy</a>
                                    <a onClick={goToTerms} href="">Terms of Use</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="wrap-copy-right">
                        <div className="copy-right-item1">
                            © 2025 TinyBlock Ltd. All Rights Reserved.
                        </div>
                        {/* <div className="copy-right-item1" onClick={goTotop}>
                            Back to the top
                            <img src="/images/top.png" alt="" />
                        </div> */}

                        {/* <span>Privacy Policy</span> <span>Term & Conditions</span> */}
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer